<div class="print-preview scrollable-print-preview">
    <div class="preview-tab-area">
        <seal-status-banner
            [isSealed]="isSealed"
            [sealedAt]="sealedAt"
            [sealedBy]="sealedBy"
            [hasSealHistory]="hasSealHistory"
            (sealClicked)="sealClicked.emit()"
            (unsealClicked)="unsealClicked.emit()"
            (auditLogClicked)="auditLogClicked.emit()"
            style="margin-left: 24px; margin-top: 20px;"
        ></seal-status-banner>
    <div class="tabs-area" [class.tabs-area--with-action]="showTranslationButton || translationReviewOpen">
            <div class="translation-actions" *ngIf="showTranslationButton || translationReviewOpen">
                <button
                    *ngIf="translationReviewOpen; else manageTranslation"
                    aum-button
                    color="basic"
                    class="translation-save"
                    (click)="saveTranslationClicked.emit()"
                >
                    {{ 'aumico_annual_report_translation_save' | i18next }}
                </button>
                <button
                    *ngIf="translationReviewOpen"
                    type="button"
                    class="translation-legend-button"
                    [attr.aria-label]="'aumico_annual_report_translation_legend_title' | i18next"
                    (click)="translationLegendClicked.emit()"
                >
                    <i class="info-outline-icon"></i>
                </button>
                <ng-template #manageTranslation>
                    <button
                        aum-button
                        color="basic"
                        [disabled]="isSealed"
                        [hamDisabledTooltip]="'aumico_annual_report_translation_sealed_tooltip' | i18next"
                        (click)="manageTranslationClicked.emit()"
                    >
                        {{ 'aumico_annual_report_translation_manage' | i18next }}
                    </button>
                </ng-template>
            </div>
    <mat-tab-group (selectedTabChange)="onTabSelectionChange($event)">
        <mat-tab
            *ngFor="let printPreviewLocaleAvailable of printPreviewLocalesAvailable"
            label="{{ LocaleLocalizationKeysMap.get(printPreviewLocaleAvailable.toLowerCase()) | i18next }}"
        >
            <ng-container *ngIf="printDisplayOptions != null && printStyleOptions != null">
                <div class="print-preview-data scroll-style">
                    <div
                        [style.order]="-3"
                        class="print-content-preview"
                        stylePreference
                        [textColor]="printStyleOptions.textColor"
                    >
                        <h2>
                            {{ "aumico_annual_report_print_page_content_preview" | i18nextWithLocale:
                            printPreviewLocaleAvailable }}
                        </h2>
                        <!-- TODO: As improvement the company profile data should be displayed here (the company which are making the audit) -->
                    </div>
                    <div
                        class="logo-wrapper"
                        [style.order]="-2"
                        *ngIf="companyLogo && printOptionsDataToBeSaved?.displayOptions?.showReportCompanyLogo"
                    >
                        <img [src]="companyLogo" class="company-logo" />
                    </div>

                    <ng-container *ngIf="printDisplayOptions.showCoverSheet">
                        <div [style.order]="-2" class="{{markerClasses.COVER_PAGE}}">
                            <aumico-annual-report-cover-page
                                [printOptions]="printOptionsDataToBeSaved"
                                [reportLocale]="printPreviewLocaleAvailable"
                            >
                            </aumico-annual-report-cover-page>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="printDisplayOptions.showTableOfContents">
                        <div [style.order]="-1" class="{{markerClasses.TOC}}">
                            <aumico-annual-report-toc-page
                                [styleOptions]="printStyleOptions"
                                [orderedSectionsTitles]="orderedSectionsTitles"
                                [orderedSectionsIds]="orderedSectionsIds"
                                [notesDetails]="notesDetails"
                                [activeLocale]="printPreviewLocaleAvailable"
                                [complementaryReportsAsAppendix]="complementaryReportsAsAppendix"
                                [complementaryReports]="complementaryReports"
                                [appendixSectionTitle]="appendixSectionTitle"
                            >
                            </aumico-annual-report-toc-page>
                        </div>
                    </ng-container>

                    <ng-container
                        *ngIf="printOptionsDataToBeSaved?.displayOptions?.finStatementHideDecimalPlacesValues || 
                            printOptionsDataToBeSaved?.displayOptions?.notesHideDecimalPlacesValues || 
                            printOptionsDataToBeSaved?.displayOptions?.aopHideDecimalPlacesValues ||
                            printOptionsDataToBeSaved?.displayOptions?.finStatementRoundToThousands ||
                            printOptionsDataToBeSaved?.displayOptions?.notesRoundToThousands ||
                            printOptionsDataToBeSaved?.displayOptions?.aopRoundToThousands"
                    >
                        <div class="rounding-disclaimer">
                            <span>
                                {{ "aumico_annual_report_print_page_rounding_disclaimer" | i18nextWithLocale:
                                printPreviewLocaleAvailable }}
                            </span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="complementaryReportsAtTheStart.length > 0">
                        <div *ngFor="let complementaryReportAtTheStart of complementaryReportsAtTheStart">
                            <aumico-annualReport-complementary-report-swiss-print-preview-page
                                [stylePreferenceOptions]="printStyleOptions"
                                [complementaryReportSectionId]="complementaryReportAtTheStart.sectionId"
                            >
                            </aumico-annualReport-complementary-report-swiss-print-preview-page>
                        </div>
                    </ng-container>

                    <div style="display: none">
                        <div
                            #aopSnapshot
                            id="aopSnapshot"
                            *ngIf="this.activeAnnualReport.appropriationOfProfit != null"
                            class="aop-snapshot"
                        >
                            <aumico-annualReport-appropriation-of-profit-german-display-component
                                [stylePreferenceOptions]="printStyleOptions"
                                [appropriationOfProfitSection]="appropriationOfProfitSection"
                                [noPreviousData]="noPreviousData"
                                [isSnapshot]="true"
                            >
                            </aumico-annualReport-appropriation-of-profit-german-display-component>
                        </div>
                    </div>

                    <div style="display: none">
                        <div
                            #aopSnapshotCurrentYear
                            id="aopSnapshotCurrentYear"
                            *ngIf="this.activeAnnualReport.appropriationOfProfit != null"
                            class="aop-snapshot-current-year"
                        >
                            <aumico-annualReport-appropriation-of-profit-german-display-component
                                [stylePreferenceOptions]="printStyleOptions"
                                [appropriationOfProfitSection]="appropriationOfProfitSection"
                                [noPreviousData]="true"
                                [isSnapshot]="true"
                            >
                            </aumico-annualReport-appropriation-of-profit-german-display-component>
                        </div>
                    </div>

                    <ng-container *ngFor="let orderedSectionsId of orderedSectionsIds; let index;">
                        <div
                            [style.order]="index"
                            *ngIf="orderedSectionsId === SectionIds.FINANCIAL_CLOSING_PROCESS"
                            class="{{markerClasses.FINANCIAL_CLOSING_PROCESS}}"
                        >
                            <aumico-financial-closing-process-adapter
                                renderingMode="{{ArFeatureRenderingMode.PRINT_PREVIEW}}"
                                translationLocale="printPreviewLocaleAvailable"
                                #fcpAdapter
                            ></aumico-financial-closing-process-adapter>
                        </div>
                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.BALANCE">
                            <annual-report-account-mapping-german-display
                                reportType="balance"
                                [printOptions]="printOptionsDataToBeSaved"
                                [noPreviousData]="noPreviousData"
                                [markerClass]="markerClasses.BALANCE"
                                [activeLocale]="printPreviewLocaleAvailable.toLowerCase()"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            >
                            </annual-report-account-mapping-german-display>
                        </div>

                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.APBS">
                            <annual-report-account-proof-german-print-preview
                                reportType="balance"
                                [noPreviousData]="noPreviousData"
                                [printOptions]="printOptionsDataToBeSaved"
                                [markerClass]="markerClasses.ACCOUNT_PROOF_BALANCE"
                                [textColor]="printStyleOptions.textColor"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            >
                            </annual-report-account-proof-german-print-preview>
                        </div>

                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.INCOME">
                            <annual-report-account-mapping-german-display
                                reportType="income"
                                [printOptions]="printOptionsDataToBeSaved"
                                [noPreviousData]="noPreviousData"
                                [noPreviousData]="noPreviousData"
                                [markerClass]="markerClasses.INCOME"
                                [activeLocale]="printPreviewLocaleAvailable.toLowerCase()"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            >
                            </annual-report-account-mapping-german-display>
                            <aumico-annual-report-signature-page
                                *ngIf="printSignatureOptions.hasSignature && !printSignatureOptions.placeSignatureAfterAop"
                                [printOptions]="printOptionsDataToBeSaved"
                            >
                            </aumico-annual-report-signature-page>
                        </div>

                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.APIS">
                            <annual-report-account-proof-german-print-preview
                                reportType="income"
                                [noPreviousData]="noPreviousData"
                                [printOptions]="printOptionsDataToBeSaved"
                                [markerClass]="markerClasses.ACCOUNT_PROOF_INCOME"
                                [textColor]="printStyleOptions.textColor"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            >
                            </annual-report-account-proof-german-print-preview>
                        </div>

                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.CASHFLOW">
                            <cash-flow-statement-german-display
                                class="{{markerClasses.CASHFLOW}}"
                                [noPreviousData]="noPreviousData"
                                [printOptions]="printOptionsDataToBeSaved"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            ></cash-flow-statement-german-display>
                        </div>

                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.NOTES">
                            <aumico-notes-german-display
                                class="{{markerClasses.NOTES}}"
                                [noPreviousData]="noPreviousData"
                                [textColor]="printStyleOptions.textColor"
                                [printOptions]="printOptionsDataToBeSaved"
                                [currentActiveLocale]="currentActiveLocale"
                                [reportLocale]="reportLocale"
                                [translations]="translationsBlock"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            ></aumico-notes-german-display>
                        </div>

                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.AOP">
                            <aumico-annualReport-appropriation-of-profit-german-print-preview-page
                                [stylePreferenceOptions]="printStyleOptions"
                                [noPreviousData]="noPreviousData"
                                [textColor]="printStyleOptions.textColor"
                                [markerClass]="markerClasses.AOP"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            >
                            </aumico-annualReport-appropriation-of-profit-german-print-preview-page>
                            <aumico-annual-report-signature-page
                                *ngIf="printSignatureOptions.hasSignature && printSignatureOptions.placeSignatureAfterAop"
                                [printOptions]="printOptionsDataToBeSaved"
                            >
                            </aumico-annual-report-signature-page>
                        </div>

                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.EMS">
                            <aumico-annualReport-equity-movement-schedule-german-print-preview-page
                                [styleOptions]="printStyleOptions"
                                [textColor]="printStyleOptions.textColor"
                                [markerClass]="markerClasses.EMS"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            >
                            </aumico-annualReport-equity-movement-schedule-german-print-preview-page>
                        </div>

                        <div [style.order]="index" *ngIf="orderedSectionsId === SectionIds.FAS">
                            <aumico-annualReport-fixed-assets-schedule-german-display-component
                                [stylePreferenceOptions]="printStyleOptions"
                                [markerClass]="markerClasses.FAS"
                                (sectionTitleChanged)="onSectionTitleChanged($event, orderedSectionsId)"
                            >
                            </aumico-annualReport-fixed-assets-schedule-german-display-component>
                        </div>

                        <div
                            [style.order]="index"
                            *ngIf="orderedSectionsId.includes(SectionIds.COMPLEMENTARY_REPORT) && showComplementaryReportsInOldLocation"
                        >
                            <aumico-annualReport-complementary-report-german-print-preview-page
                                [stylePreferenceOptions]="printStyleOptions"
                                [complementaryReportSectionId]="orderedSectionsId"
                            >
                            </aumico-annualReport-complementary-report-german-print-preview-page>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="complementaryReportsAtTheEnd.length > 0">
                        <div *ngFor="let complementaryReportAtTheEnd of complementaryReportsAtTheEnd">
                            <aumico-annualReport-complementary-report-swiss-print-preview-page
                                [stylePreferenceOptions]="printStyleOptions"
                                [complementaryReportSectionId]="complementaryReportAtTheEnd.sectionId"
                            >
                            </aumico-annualReport-complementary-report-swiss-print-preview-page>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="complementaryReportsAsAppendix.length > 0">
                        <div class="{{markerClasses.APPENDIX}}">
                            <div class="table-title">
                                <ng-container>
                                    <span
                                        class="sectionTitle"
                                        stylePreference
                                        [textColor]="printStyleOptions.textColor"
                                    >
                                        {{appendixSectionTitle}}
                                    </span>
                                </ng-container>
                                <mat-icon
                                    class="edit-icon"
                                    svgIcon="aumico-pattern-icon-edit-write"
                                    (click)="editAppendixSectionTitle()"
                                ></mat-icon>
                            </div>
                            &nbsp;
                        </div>
                        <div *ngFor="let complementaryReportAsAppendix of complementaryReportsAsAppendix">
                            <aumico-annualReport-complementary-report-swiss-print-preview-page
                                [stylePreferenceOptions]="printStyleOptions"
                                [complementaryReportSectionId]="complementaryReportAsAppendix.sectionId"
                            >
                            </aumico-annualReport-complementary-report-swiss-print-preview-page>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </mat-tab>
    </mat-tab-group>
    </div>
    </div>

    <div class="print-preview-options overflow-auto scroll-style">
        <div style="margin-bottom: 20px">
            <equality-check-print-preview-table
                [equalityCheckDataCurrentYear]="equalityCheckDataCurrentYear"
                [equalityCheckDataPreviousYear]="equalityCheckDataPreviousYear"
                [noPreviousYear]="noPreviousData"
                [printOptionsVisibility]="printOptionsVisibility"
                [currentYear]="currentYear"
                [previousYear]="previousYear"
            ></equality-check-print-preview-table>
        </div>
        <aumico-annualreports-print-options
            [fxEnabled]="activeAnnualReport?.setupData?.fxEnabled === true"
            [reportSectionsTitles]="printOptionsDataToBeSaved != null ? printOptionsDataToBeSaved.reportSectionsTitles : printOptionsData?.reportSectionsTitles"
            [printOptionsSavedData]="printOptionsData"
            [organizationSettings]="organizationSettings"
            [printOptionsVisibility]="printOptionsVisibility"
            [defaultPrintDisplayOptions]="defaultGermanDisplayOptions"
            [mainTitleDefaultValue]="mainTitleDefaultValue"
            [subtitleDefaultValue]="subTitleDefaultValue"
            [previousDateTitleDefaultValue]="previousDateTitleDefaultValue"
            [currentDateTitleDefaultValue]="currentDateTitleDefaultValue"
            [incomeItemsOptionsForCalculatingRatio]="incomeItemsOptionsForCalculatingRatio"
            [complementaryReports]="complementaryReports"
            (printOptions)="onPrintOptionsValueChanged($event)"
            (initialPrintOptions)="onInitialPrintOptionsValueReady($event)"
            (triggerInitialIncomeItemsOptionsPreparationForRatioCalculation)="onTriggeringInitialIncomeItemsOptionsPreparationForRatioCalculation()"
            (incomeItemForCalculatingRatioSelectionChange)="onIncomeItemForCalculatingRatioSelectionChange($event)"
            [disableShowEmsToggle]="disableShowEmsToggle"
            (showCompanyLogo)="onShowCompanyLogo($event)"
            (printComplementaryReport)="onPrintComplementaryReportClicked($event)"
        ></aumico-annualreports-print-options>
    </div>
</div>
